module.exports = __webpack_public_path__ + "static/media/Icono bolsas.07c91d6e.svg";